import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "ar-cube-1" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.89691 2.0099C8.58184 1.62463 9.41816 1.62463 10.1031 2.0099L14.6031 4.54115C14.7304 4.61278 14.849 4.69574 14.9579 4.78838L9.00042 8.13954L3.0423 4.78818C3.15114 4.69562 3.26967 4.61272 3.39691 4.54115L7.89691 2.0099ZM2.28888 6.08541C2.26326 6.22142 2.25 6.36085 2.25 6.5022V11.4977C2.25 12.3105 2.68844 13.0602 3.39691 13.4587L7.89691 15.99C8.01102 16.0541 8.12932 16.1076 8.25043 16.1504V9.43869L2.28888 6.08541ZM9.75043 16.1501C9.87124 16.1074 9.98925 16.054 10.1031 15.99L14.6031 13.4587C15.3116 13.0602 15.75 12.3105 15.75 11.4977V6.5022C15.75 6.36096 15.7368 6.22162 15.7112 6.08571L9.75043 9.43868V16.1501Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }